import * as React from 'react';
import MikeNotificationChip from './MikeNotificationChip';
import MikeNotificationTitle from './MikeNotificationTitle';
import mikeChipTextResources from './mikeChipTextResourcesEn';
import styles from '../Style/Notifications.module.scss';
import { INotification } from '../INotification';

export const renderNotificationTitle = (notification: INotification) => {
  return (
    <div className={styles.mikeNotificationTitleContainer}>
      <MikeNotificationTitle title={notification.title} />
      {notification.type && (
        <MikeNotificationChip
          type={notification.type}
          textResources={mikeChipTextResources}
        />
      )}
    </div>
  );
};
